<template id="modal-template">
    <transition v-if="show && fair" name="modal" appear>
        <div class="modal-container modal-container--scrollable">
            <div class="modal-wrapper">
                <div class="modal">
                    <div class="modal__head">
                        <h1 class="modal__title">
                            <span>매칭상담회 기간 중 참여 가능한 스케줄을 설정해주세요</span>
                            <small>추후 수정을 원하실 경우 [마이페이지-매칭상담회-매칭스케줄]에서 수정을 부탁드립니다</small>
                        </h1>
                        <button class="modal__close" type="button" @click="close">
                            <img src="/images/icon/close-rounded.png" alt="">
                        </button>
                    </div>
                    <div class="modal__body">
                        <matching-schedule :fair="fair" @save="save"></matching-schedule>
                    </div>
                    <div class="modal__foot">
                        
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>


<script>
import MatchingSchedule from "./matching-schedule.vue";

export default {
    components: {
        MatchingSchedule
    },
    data() {
        return {
            show: false,
            fair: null
        };
    },
    methods: {
        open(){
            this.show = true;
            document.querySelector('html').setAttribute('data-modal', 'opened');
        },
        close(){
            this.show = false;
            document.querySelector('html').removeAttribute('data-modal');
        },
        save(){
            this.$emit("save");
            this.close();
        },
    }
}
</script>
<style lang="scss" scoped>
@import "@/styles/_variables.scss";

.modal__foot{
    &__buttons { display: flex; justify-content: center; margin-top: 50px; }
    &__buttons .button { padding: 10px 40px 12px; line-height: 1; }
}

</style>